import { gql } from '@apollo/client';
export const FAVORITE_FIELDS = gql`
  fragment FavoriteFields on FavoriteDto {
    name
    objectTypeId
    objectId
    id
    url
  }
`;